import { httpGet, tdSendHttpPostReq } from "../../../setup/axios/axiosUtils";
import { useState } from "react";
import { v4 as uuid } from "uuid";

import {
  CONST_CONF,
  CONST_LABELS,
  CONST_TERMS,
  getProductId,
  getPinLength,
} from "../../pages/Commons";
import axios from "axios";
const strUtil = require("util");

const useSendOtp = () => {
  const [loading, setLoading] = useState<boolean>(false);
  // const [productId, setProductId] = useState<any>(Number(CONST_LABELS.get("PRODUCT_ID_1")));
  const [pinLength, setPinLength] = useState<Number>(Number(CONST_LABELS.get("PIN_LENGTH")));
  const jsonStr = `{apiver: "2", reqtype: "portal", reqidFrmPixelCompany: "'.$unique.'",}`;

  const sendOtpHandler = async (
    // client_id: string,
    phoneNumber: string,
    // requestFor: string,
    // productId: string,
    reqId: string,
    resourceKey: string
  ) => {
    setLoading(true);
    let jsonRes = null;
    try {
      /*
      let res = await httpGet(
        `ReactProxy/getProxyGetSendPin?clientunqid=${client_id}&msisdn=${phoneNumber}&reqFor=${requestFor}`
      );
        */
      let res;
      var custInfoRes = [];
      try {
        
        // var prd = productId;
        
        // setPinLength(5);//zain Pin legth is 5

        var countrycode = Number(CONST_LABELS.get("COUNTRY_CODE"));
        // 42	BATELCO_BHR: Koode Monthly, 41	Zain_BAH:Koode Monthly
        // prd = "" + getProductId(phoneNumber, countrycode);

        // var pinL = getPinLength(prd);
        // setProductId(prd);
        // var chosenProduct = strUtil.format(CONST_LABELS.get("PRODUCT_ID_1"));
        // // setProductId(chosenProduct);
        // var productId = chosenProduct;
        // console.log(productId);

        // const urlStr: string = strUtil.format(
        //   CONST_CONF.get("URL_SUB_REQ"),
        //   CONST_CONF.get("AFF_USR"),
        //   productId
        // );
        const urlStr: string = "/provider/api/subRequest"
       
        // const jsonBody: any = strUtil.format(
        //   CONST_CONF.get("JSON_SUB_REQ"),
        //   phoneNumber,
        //   reqId, //uuid(),
        //   CONST_CONF.get("AFF_SRC"),
          
        // );
        const jsonBody = {
          "source":"MPLP",
          "packName": "TOONZ_DAILY",
          "planName": "DAILY",
          "countryCode": "971",
          "userId": phoneNumber
      }

      //  var resJson = await tdSendHttpPostReq(urlStr, jsonBody, reqId, resourceKey);
        console.log(
          "Req: " + urlStr + " " + jsonBody + ", prd: " + "prd" + ", pinL:" + "pinL"
        );
       // console.log("Resonse--->: " + JSON.stringify(resJson));

        //custInfoRes = resJson;
      } catch (err) {
        custInfoRes = [];
      }
      setLoading(false);
      //res = custInfoRes;
      jsonRes = res;

      //console.log(res);
    } catch (e) {
      setLoading(false);
    }
    return jsonRes;
  };

  const checkOtpHandler = async (providerName: string, providerType: string, pin: string, phoneNumber: string, reqId: string, resourceKey:string) => {
    setLoading(true);
    let jsonRes = null;
    try {
      /*
      let res = await httpGet(
        `ReactProxy/getProxyGetSendPin?clientunqid=${client_id}&msisdn=${phoneNumber}&reqFor=${requestFor}`
      );
        */
      let res;
      var custInfoRes = [];
      try {
        // const urlStr: string = strUtil.format(
        //   CONST_CONF.get("URL_SUB_CONFIRM_REQ"),
        //   CONST_CONF.get("AFF_USR"),
        //   productId
        // );
        // const jsonBody: any = strUtil.format(
        //   CONST_CONF.get("JSON_SUB_CONFIRM_REQ"),
        //   subReqId,
        //   pin,
        //   phoneNumber,
        //   );
        const urlStr = "/provider/api/subConfirm"
        const jsonBody = {
          "source":"MPLP",
          "packName": "TOONZ_DAILY",
          "planName": "DAILY",
          "providerName": providerName,
          "providerType": providerType, 
          "userId": phoneNumber,
          "otp": pin
      }
        var resJson = await tdSendHttpPostReq(urlStr, jsonBody, reqId, resourceKey);
        //console.log("Resonse--->: "+JSON.stringify(resJson));
        //custInfoRes = resJson;
      } catch (err) {
        custInfoRes = [];
      }
      setLoading(false);
      //res = custInfoRes;
      jsonRes = res;
      //console.log(res);
    } catch (e) {
      setLoading(false);
    }
    return jsonRes;
  };

  return {
    loading,
    sendOtpHandler,
    checkOtpHandler,
  };
};
export default useSendOtp;
